import {useAccounts, UserContext} from "@hosttools/frontend";
import {type AccountType} from "@hosttools/frontend/models/account";
import {useContext, useMemo} from "react";

const useAccountsByType = (accountType: AccountType) => {
    const {accounts} = useContext(UserContext);
    const {channels, badChannels} = useAccounts(accounts);

    return useMemo(() => {
        return {
            accounts: channels.filter(elem => elem.type === accountType),
            badAccounts: badChannels.filter(elem => elem.type === accountType)
        };
    }, [channels, badChannels, accountType]);
};

export default useAccountsByType;
